import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DataSourcesFileFormatList } from '../../lists/data-sources-file-format.list';
import { DataSourcesAdditionsComponent } from '../data-source-additions/data-sources-additions.component';
import { DataSourceUniqueNameComponent, DataSourceVisibilityComponent } from '../data-source-form-inputs';
import { DataSourcesBasic } from '../data-sources-basic';

@Component({
  selector: 'selfai-platform-data-sources-hdfs',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,
    RadioButtonModule,
    TranslateModule,
    DataSourcesAdditionsComponent,
    DataSourceUniqueNameComponent,
    DataSourceVisibilityComponent,
  ],
  templateUrl: './data-sources-hdfs.component.html',
  styleUrls: ['./data-sources-hdfs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSourcesHdfsComponent extends DataSourcesBasic implements OnInit {
  private readonly translate = inject(TranslateService);

  format = DataSourcesFileFormatList;
  separators = [
    { id: 'comma', labelTranslate: this.translate.instant('data-source.common.separator.comma') },
    { id: 'semicolon', labelTranslate: this.translate.instant('data-source.common.separator.semicolon') },
    { id: 'colon', labelTranslate: this.translate.instant('data-source.common.separator.colon') },
    { id: 'space', labelTranslate: this.translate.instant('data-source.common.separator.space') },
    { id: 'tab', labelTranslate: this.translate.instant('data-source.common.separator.tab') },
    { id: 'custom', labelTranslate: this.translate.instant('data-source.common.separator.custom') },
  ];
  customParamsVisible = true;

  paramsForm = this.fb.group({
    hdfsPath: ['', Validators.required],
    fileFormat: ['csv'],
    csvFileFormatParams: this.fb.group({
      convert01ToBoolean: [false],
      includeHeader: [false],
      separatorType: ['comma'],
      customSeparator: [''],
    }),
  });

  constructor() {
    super('hdfs');
  }

  changeFormat(value: string): void {
    this.customParamsVisible = value === 'csv';
  }
}
